'use client';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib';
import { ImageProps } from 'next/image';
import React, { useState } from 'react';
import { CommonImage } from '@/components/common';

type ImageLoaderProps = Omit<ImageProps, 'onLoadingComplete'> & {
  className?: React.ComponentProps<'div'>['className'];
  imageClassName?: React.ComponentProps<'img'>['className'];
};

export default function ImageLoader({
  src,
  alt,
  className = '',
  imageClassName = '',
  ...rest
}: ImageLoaderProps): React.ReactNode {
  const [loaded, setLoaded] = useState<boolean>(false);

  return (
    <div
      className={cn(`relative w-full`, className)}
      style={{
        aspectRatio:
          rest.width && rest.height
            ? `${rest.width} / ${rest.height}`
            : undefined,
        overflow: 'hidden',
      }}
    >
      {!loaded && (
        <Skeleton
          className='absolute top-0 left-0 h-full w-full'
          style={{
            zIndex: -1,
          }}
        />
      )}
      <CommonImage
        src={src}
        alt={alt}
        style={{
          opacity: loaded ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
        className={cn('h-full w-full rounded-none', imageClassName)}
        onLoad={() => setLoaded(true)}
        {...rest}
      />
    </div>
  );
}
